import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Sessions
export const listReporterSessions = () => axios.get(`${API}/reporter/sessions`);
export const createReporterSession = (data) => axios.post(`${API}/reporter/sessions`, data);
export const getReporterSession = (id) => axios.get(`${API}/reporter/sessions/${id}`);
export const updateReporterSession = (id, data) => axios.put(`${API}/reporter/sessions/${id}`, data);
export const pauseReporterSession = (id) => axios.post(`${API}/reporter/sessions/${id}/pause`);
export const completeReporterSession = (id) => axios.post(`${API}/reporter/sessions/${id}/complete`);

// Days
export const listReporterDays = (id) => axios.get(`${API}/reporter/sessions/${id}/days`);
export const createReporterDay = (id, data) => axios.post(`${API}/reporter/sessions/${id}/days`, data);
export const activateReporterDay = (id, dayId) => axios.post(`${API}/reporter/sessions/${id}/days/${dayId}/activate`);
export const closeReporterDay = (id, dayId) => axios.post(`${API}/reporter/sessions/${id}/days/${dayId}/close`);
export const getReporterTimeline = (id, dayId) =>
  axios.get(`${API}/reporter/sessions/${id}/timeline`, { params: dayId ? { day_id: dayId } : {} });

// Captures / notes / voice / location
export const listReporterCaptures = (id, dayId) =>
  axios.get(`${API}/reporter/sessions/${id}/captures`, { params: dayId ? { day_id: dayId } : {} });
export const getDaySuggestions = (id) => axios.get(`${API}/reporter/sessions/${id}/day-suggestions`);
export const assignCaptureDay = (captureId, dayId) =>
  axios.put(`${API}/reporter/captures/${captureId}/assign-day`, { day_id: dayId });

export const uploadCapture = (form) =>
  axios.post(`${API}/reporter/captures`, form, { headers: { "Content-Type": "multipart/form-data" } });
export const createReporterNote = (data) => axios.post(`${API}/reporter/notes`, data);
export const uploadVoiceNote = (form) =>
  axios.post(`${API}/reporter/voice-notes`, form, { headers: { "Content-Type": "multipart/form-data" } });
export const processVoiceNote = (voiceId) => axios.post(`${API}/reporter/voice-notes/${voiceId}/process`);
export const listVoiceNotes = (id) => axios.get(`${API}/reporter/sessions/${id}/voice-notes`);
export const createLocationEvent = (id, data) => axios.post(`${API}/reporter/sessions/${id}/location-events`, data);
export const listLocationEvents = (id) => axios.get(`${API}/reporter/sessions/${id}/location-events`);

// Blue / memory / article
export const analyzeSession = (id) => axios.post(`${API}/reporter/sessions/${id}/analyze`);
export const buildArticle = (id) => axios.post(`${API}/reporter/sessions/${id}/build-article`);
export const getMemory = (id, level) =>
  axios.get(`${API}/reporter/sessions/${id}/memory`, { params: level ? { level } : {} });
export const getArticleSuggestions = (id) => axios.get(`${API}/reporter/sessions/${id}/article-suggestions`);

// Notifications
export const getReporterNotifications = () => axios.get(`${API}/reporter/notifications`);
export const markReporterNotificationRead = (nid) => axios.post(`${API}/reporter/notifications/${nid}/read`);
